import { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { AppBar } from "@mui/material";
import {
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Loading,
} from "../../components";
import "./topbar.style.css";
import {
  MeuUsuarioService,
  notification,
  SessionService,
} from "../../services";
import { formatCnpj, formatCpf, responseErros } from "../../utils";
import { useImportContext } from "../../contexts/import.context";

const Topbar = ({ handleDrawerOpen, open }) => {
  const [empresa, setEmpresa] = useState(null);
  const [anchorEmpresas, setAnchorEmpresas] = useState(null);
  const [loading, setLoading] = useState(false);
  const { initialCollapses } = useImportContext();
  const sessionService = new SessionService();
  const meuUsuarioService = new MeuUsuarioService();
  const dadosUsuarioAndEmpresa = sessionService.getEmpresaAndUsuario();
  const empresasAcesso = dadosUsuarioAndEmpresa?.usuario?.acessosEmpresas || [];

  useEffect(() => {
    setEmpresa(dadosUsuarioAndEmpresa.empresa);
  }, []);

  const handleAbrirMenuEmpresas = (event) => {
    setAnchorEmpresas(event.currentTarget);
  };

  const handleFecharMenuEmpresas = () => {
    setAnchorEmpresas(null);
  };

  const trocarEmpresa = async (empresaId) => {
    if (empresa.id !== empresaId) {
      setLoading(true);
      const response = await meuUsuarioService.trocarToken(empresaId);
      setLoading(false);
      if (!response.isAxiosError) {
        sessionService.setEmpresa(response.data.dados.empresa);
        sessionService.setToken(response.data.token);
        window.location.reload();
      } else {
        responseErros(response);
      }
    }
    handleFecharMenuEmpresas();
  };

  const handleLogout = async () => {
    const confirm = await notification.confirmacao(
      "Sair",
      "Tem certeza que deseja sair?",
    );
    if (confirm.value === true) {
      initialCollapses();
      sessionService.deslogar();
    }
  };

  const handleDrawerTransition = () => {
    handleDrawerOpen();
  };

  return (
    <>
      <AppBar
        sx={{
          backgroundColor: "#ffffff",
          borderBottomLeftRadius: 16,
          borderBottomRightRadius: 16,
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
          width: {
            md: `calc(100% - ${open ? "18.5rem" : "5rem"})`,
            xs: "100%",
          },
          left: { md: `${open ? "18.5rem" : "5rem"}`, xs: 0 },
          transition: "width 0.3s ease, left 0.3s ease",
        }}
      >
        <Toolbar className={open && "topbarQuery"}>
          <IconButton
            edge="start"
            color="primary"
            aria-label="open drawer"
            onClick={handleDrawerTransition}
            style={{ borderRadius: 8, marginLeft: 2 }}
          >
            {open ? (
              <i
                className="ph-fill ph-dots-three-outline-vertical"
                style={{ fontSize: "clamp(17px, 4vw, 22px)" }}
              />
            ) : (
              <i
                className="ph-bold ph-list"
                style={{ fontSize: "clamp(17px, 4vw, 22px)" }}
              />
            )}
          </IconButton>

          <div style={{ flex: 1 }} />

          {empresa && (
            <div>
              <IconButton
                className="me-1"
                style={{
                  padding: "8px 12px",
                  borderRadius: 12,
                  boxShadow: "0px 0px 56px rgba(0, 0, 0, 0.08)",
                }}
                color="inherit"
              >
                <i
                  className="ph-fill ph-buildings"
                  style={{ fontSize: "clamp(17px, 4vw, 25px)" }}
                />
                {empresa.fantasia?.length <= 40 && (
                  <div className="d-flex gap-2 align-items-center">
                    <div
                      className="d-flex flex-column text-start mx-2"
                      style={{ minWidth: 0 }}
                    >
                      <Typography
                        style={{
                          color: "#494C62",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "150px",
                        }}
                        variant="caption"
                      >
                        {empresa.fantasia}
                      </Typography>
                      <Typography
                        style={{
                          color: "#494C62",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "150px",
                        }}
                        variant="caption"
                      >
                        {empresa.cnpjCpf?.length === 11
                          ? formatCpf(empresa.cnpjCpf)
                          : formatCnpj(empresa.cnpjCpf)}
                      </Typography>
                    </div>
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAbrirMenuEmpresas(e);
                      }}
                      color="inherit"
                      style={{ borderRadius: 8 }}
                      sx={{
                        backgroundColor: "#EDEEF0",
                        "&:hover": { backgroundColor: "#B6BABC" },
                      }}
                    >
                      <i
                        className="ph-bold ph-caret-down"
                        style={{ fontSize: "clamp(8px, 4vw, 15px)" }}
                      />
                    </IconButton>
                  </div>
                )}
              </IconButton>

              <Menu
                anchorEl={anchorEmpresas}
                open={Boolean(anchorEmpresas)}
                onClose={handleFecharMenuEmpresas}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: -10, horizontal: "right" }}
                PaperProps={{
                  style: {
                    maxHeight: 300,
                    width: "35ch",
                    borderRadius: "12px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                  },
                }}
              >
                {empresasAcesso
                  .filter((empresaAcesso) => empresaAcesso.id !== empresa.id)
                  .map((emp) => (
                    <MenuItem
                      key={emp.id}
                      onClick={() => trocarEmpresa(emp.id)}
                      sx={{
                        "&.Mui-selected": {
                          backgroundColor: "#f5f5f5",
                          "&:hover": { backgroundColor: "#e0e0e0" },
                        },
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          maxWidth: "100%",
                        }}
                      >
                        <Typography variant="body2" noWrap>
                          {emp.fantasia || emp.razaoSocial}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="textSecondary"
                          noWrap
                        >
                          {emp.cnpjCpf?.length === 11
                            ? formatCpf(emp.cnpjCpf)
                            : formatCnpj(emp.cnpjCpf)}
                        </Typography>
                      </div>
                    </MenuItem>
                  ))}
                <MenuItem onClick={handleLogout}>
                  <Typography
                    variant="body2"
                    sx={{ flexGrow: 1, color: "#e44a42" }}
                  >
                    SAIR
                  </Typography>
                  <i
                    className="ph-bold ph-sign-out"
                    style={{ fontSize: 19, color: "#e44a42", marginLeft: 10 }}
                  />
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Loading open={loading} />
    </>
  );
};

Topbar.propTypes = {
  handleDrawerOpen: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Topbar));
